// src/utils/stringUtils.ts

/**
 * Safely converts a value to lowercase if it's a string, otherwise returns an empty string.
 * @param value The value to convert.
 * @returns The lowercase string, or an empty string if the value is not a string.
 */
export const safeToLowerCase = (value: unknown): string => {
  if (typeof value === 'string') {
    return value.toLowerCase();
  }
  return '';
};

